import Navbar from "../NavBar";
import SideBar from "../SideBar";
import {FaWhatsapp} from "react-icons/fa";
import Footer from "../footer";

export interface IPageContainer {
    children: React.ReactNode;
    list?: boolean
    view?: boolean
}

export default function PageContainer({children, list, view}: IPageContainer) {
    return(
        <div className={`${view ? '' : 'h-[calc(100vh_-_30px)]'}`}>
            <Navbar/>
            <div className={`flex flex-col w-full    items-center overflow-auto scrollbar z-30`}>
                <div className={'md:w-container xs:w-full  px-3 pt-5 max-h-full mb-5'}>
                    {children}
                </div>

            </div>
            <Footer/>

        </div>
    )
}
